<template>
    <div>
        <h4>Últimos Acessos por Usuário</h4>
        <hr />
        <users-last-logins-table />
    </div>
</template>

<script>
import UsersLastLoginsTable from "./components/UsersLastLoginsTable";

export default {
    name: "UsersLastLogins",
    components: {
        UsersLastLoginsTable
    },
    data() {
        return {
            users: []
        };
    },
    mounted() {}
};
</script>
